import type { Favorite } from '@tunasong/schemas'
import type { FC } from 'react'
import { useFavorites } from './favorites.hook.js'
import { List, ListItem, ListItemIcon, ListItemText, type ListProps, ListItemButton } from '../primitives/index.js'

interface FavoritesListProps extends ListProps {
  onOpen?(favorite: Favorite): void
}

export const FavoritesList: FC<FavoritesListProps> = props => {
  const { ...listProps } = props
  const { favorites } = useFavorites()
  return (
    <List {...listProps}>
      {favorites.map((favorite, index) => (
        <ListItem
          key={index}
          onClick={ev => {
            ev.stopPropagation()
            ev.preventDefault()
            if (props.onOpen) {
              props.onOpen(favorite)
            }
          }}
        >
          <ListItemButton>
            {favorite.Icon ? (
              <ListItemIcon>
                <favorite.Icon fontSize="small" />
              </ListItemIcon>
            ) : null}
            <ListItemText primary={favorite.name} secondary={favorite.entityType} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  )
}

export default FavoritesList
